import {State} from '@shared/store/reducers/Index';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory, useLocation, useParams} from 'react-router-dom';
import InitSharedRepo from '../../../../../shared';
import {_setPatientAppointmentToken} from '@shared/store/actions/AppointmentSchedularAction';
import NavRoutes from 'src/constants/route/NavRoutes';

const AppointmentPortalWrapperHOC = <T extends Record<string, any>>(
  Component: React.ComponentType<T>
): ((props: T) => JSX.Element) => {
  const AllowedComponent = (props: T): JSX.Element => {
    const {code} = useParams<{code?: string}>();
    const isLogin = useSelector((state: State) => {
      return state.appointmentPortal.isLogin;
    });
    const location = useLocation<{fromPaymentPortal?: boolean}>();
    const dispatch = useDispatch();
    const history = useHistory();
    const loginRedirect = (token: string): void => {
      history.push(
        `/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.BASE}/${token}/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.LOGIN}`
      );
    };
    if (!isLogin) {
      // CHECK WHETHER CAME TO THIS SCREEN FROM PAYMENT PORTAL
      if (location?.state?.fromPaymentPortal) {
        dispatch(_setPatientAppointmentToken(code));
        return <Component {...props} />;
      } else if (code) {
        // check whether it has come from the payments portal
        InitSharedRepo.initAfterAuth({token: code});
        dispatch(_setPatientAppointmentToken(code));
        loginRedirect(code);
      }
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <React.Fragment />;
    }
    return <Component {...props} />;
  };
  return AllowedComponent;
};

export default AppointmentPortalWrapperHOC;
